import OrderComments from './orderComments';
import OrderEquipments from './equipmentDetails';
import ListDetails from './listDetails';
import {
  getFormattedDate,
  getFormattedUnixDate,
  camel2title
} from '../utils/utils';
import FR from '../../FR.json';
import EN from '../../EN.json';

/* eslint-disable camelcase */
const locale = localStorage.getItem('locale');
const assignedText = locale === 'FR' ? 'Non attribué' : 'Unassigned';
const TRANSLATION = locale === 'FR' ? FR.general : EN.general;
const getBoolean = val => (val ? TRANSLATION.yes : TRANSLATION.no);

class OrderSummaryModel {
  constructor(data) {
    const {
      order_id,
      createdAt,
      status,
      s1_sw_lead_source_company,
      s2_customerinformation_legal_business_name,
      s2_channelrep_agent_name,
      completedAt,
      orderAssignedTo
    } = data || {};
    this.order_id = order_id;
    this.createdAt = getFormattedDate(
      createdAt,
      'dddd, MMMM Do YYYY, h:mm:ss a'
    );
    this.status = status;
    this.s1_sw_lead_source_company = s1_sw_lead_source_company;
    this.s2_customerinformation_legal_business_name = s2_customerinformation_legal_business_name;
    this.s2_channelrep_agent_name = s2_channelrep_agent_name;
    this.completedAt =
      getFormattedDate(completedAt, 'dddd, MMMM Do YYYY, h:mm:ss a') || '-';
    this.orderAssignedTo =
      (orderAssignedTo &&
        `${orderAssignedTo.first_name} ${orderAssignedTo.last_name}`) ||
      assignedText;
  }
}

class OptOrderSummaryModel {
  constructor(data) {
    const { order_id, createdAt, optBan, optReason, optNews } = data || {};

    this.order_id = order_id;
    this.createdAt = getFormattedDate(
      createdAt,
      'dddd, MMMM Do YYYY, h:mm:ss a'
    );
    this.optBan = optBan;
    this.optReason = optReason;
    this.optNews = getBoolean(optNews);
  }
}

class SalesOrderCheckListPageModel {
  constructor(data) {
    const {
      s1_sw_lead_source_company,
      s1_activation_language,
      s1_order_for,
      s1_province,
      s1_sw_multi_site,
      s1_sw_multi_site_case_numbers,
      s1_sw_order_selections,
      diy,
      s1_transaction_type,
      s1_associated_outlet_id,
      s1_call_type,
      s1_sw_sale_source,
      s1_sw_customer_existing_services,
      s1_adt_account_number,
      s1_adt_moving,
      s1_adt_moving_date,
      project_code,
      s2_sw_home_based_business,
      contractLanguagePreference
    } = data || {};
    this.s1_sw_lead_source_company = s1_sw_lead_source_company;
    this.s1_activation_language = s1_activation_language;
    this.s1_order_for = camel2title(s1_order_for);
    this.s1_province = camel2title(s1_province);
    this.s1_sw_multi_site = s1_sw_multi_site;
    this.s1_sw_multi_site_case_numbers = s1_sw_multi_site_case_numbers;
    this.s1_sw_order_selections = s1_sw_order_selections;
    this.diy = diy;
    this.s1_transaction_type = s1_transaction_type;
    this.s1_associated_outlet_id = s1_associated_outlet_id;
    this.s1_call_type = s1_call_type;
    this.s1_sw_sale_source = s1_sw_sale_source;
    this.s1_sw_customer_existing_services = s1_sw_customer_existing_services;
    this.s1_adt_account_number = s1_adt_account_number;
    this.s1_adt_moving = s1_adt_moving;
    this.s1_adt_moving_date = s1_adt_moving_date;
    this.project_code = project_code;
    this.s2_sw_home_based_business = s2_sw_home_based_business;
    this.contractLanguagePreference = contractLanguagePreference;
  }
}

class HsiaQualificationsPageModel {
  constructor(data) {
    const {
      customer_has_existing_internet_connection,
      customer_upgrading_their_telus_internet,
      existing_internet_provider,
      private_wifi_connection,
      upload_speed,
      case_numbers,
      upload_speed_sold
    } = data || {};
    this.customer_has_existing_internet_connection = [
      'exist',
      'existingConnectionYes'
    ].includes(customer_has_existing_internet_connection)
      ? getBoolean(true)
      : customer_has_existing_internet_connection;
    this.customer_upgrading_their_telus_internet = customer_upgrading_their_telus_internet;
    this.existing_internet_provider = existing_internet_provider;
    this.private_wifi_connection = private_wifi_connection;
    this.upload_speed = upload_speed;
    this.case_numbers = case_numbers;
    this.upload_speed_sold = upload_speed_sold;
  }
}

class ChannelRepModel {
  constructor(data) {
    const {
      s2_channelrep_agent_name,
      s2_channelrep_email_address,
      s2_channelrep_contact_number,
      s2_channelrep_email_address_secondary,
      s2_channelrep_xid,
      s2_channelrep_outlet_cpms_id,
      s2_channelrep_sales_rep_pin,
      s2_channel_manager,
      s2_channel_manager_email_address,
      s1_sw_lead_source_company,
      s2_channelrep_channel_org,
      s2_channelrep_outlet_code,
      s2_channelrep_dealership,
      s2_channel_professional_title
    } = data || {};
    this.s2_channelrep_agent_name = s2_channelrep_agent_name;
    this.s2_channelrep_email_address = s2_channelrep_email_address;
    this.s2_channelrep_contact_number = s2_channelrep_contact_number;
    this.s2_channelrep_email_address_secondary = s2_channelrep_email_address_secondary;
    this.s2_channelrep_xid = s2_channelrep_xid;
    this.s2_channelrep_outlet_cpms_id = s2_channelrep_outlet_cpms_id;
    this.s2_channelrep_sales_rep_pin = s2_channelrep_sales_rep_pin;
    this.s2_channel_manager = s2_channel_manager;
    this.s2_channel_manager_email_address = s2_channel_manager_email_address;
    this.s1_sw_lead_source_company = s1_sw_lead_source_company;
    this.s2_channelrep_channel_org = s2_channelrep_channel_org;
    this.s2_channelrep_outlet_code = s2_channelrep_outlet_code;
    this.s2_channelrep_dealership = s2_channelrep_dealership;
    this.s2_channel_professional_title = s2_channel_professional_title;
  }
}
class AdministratorContactModel {
  constructor(data) {
    const {
      s2_customerinformation_administrator_name,
      s2_customerinformation_administrator_last_name,
      s2_customerinformation_administrator_telephone_number,
      s2_customerinformation_administrator_secondary_telephone_number,
      s2_customerinformation_administrator_email_address
    } = data || {};
    this.s2_customerinformation_administrator_name = s2_customerinformation_administrator_name;
    this.s2_customerinformation_administrator_last_name = s2_customerinformation_administrator_last_name;
    this.s2_customerinformation_administrator_telephone_number = s2_customerinformation_administrator_telephone_number;
    this.s2_customerinformation_administrator_secondary_telephone_number = s2_customerinformation_administrator_secondary_telephone_number;
    this.s2_customerinformation_administrator_email_address = s2_customerinformation_administrator_email_address;
  }
}

class CustomerInformationModel {
  constructor(data) {
    const {
      status,
      is_this_home_based_business,
      s2_customerinformation_legal_business_name,
      s2_customerinformation_business_type,
      s2_customerinformation_trade_oa_name,
      s2_customerinformation_business_incorporation_number,
      s2_customerinformation_registration_date,
      s2_customerinformation_driver_licence_number,
      s2_customerinformation_date_birth,
      s2_customerinformation_security_wireless_account,
      s2_customerinformation_security_wireline_account,
      s2_customerinformation_security_permit_number,
      expiration_date,
      s2_customerinformation_nonprofit_registration_number,
      s2_customerinformation_nonprofit_registration_date,
      s2_customerinformation_customer_authorized,
      doesCustomerHaveLawnOrFenceOnPremise
    } = data || {};
    this.is_this_home_based_business = is_this_home_based_business;
    this.s2_customerinformation_legal_business_name = s2_customerinformation_legal_business_name;
    this.s2_customerinformation_business_type = s2_customerinformation_business_type;
    this.s2_customerinformation_trade_oa_name = s2_customerinformation_trade_oa_name;
    this.s2_customerinformation_business_incorporation_number = s2_customerinformation_business_incorporation_number;
    this.s2_customerinformation_registration_date = getFormattedDate(
      s2_customerinformation_registration_date
    );
    if (!['Completed', 'Canceled'].includes(status)) {
      this.s2_customerinformation_driver_licence_number = s2_customerinformation_driver_licence_number;
      this.s2_customerinformation_date_birth = getFormattedDate(
        s2_customerinformation_date_birth
      );
    }
    this.s2_customerinformation_security_wireless_account = s2_customerinformation_security_wireless_account;
    this.s2_customerinformation_security_wireline_account = s2_customerinformation_security_wireline_account;
    this.s2_customerinformation_security_permit_number = s2_customerinformation_security_permit_number;
    this.expiration_date = getFormattedDate(expiration_date);
    this.s2_customerinformation_nonprofit_registration_number = s2_customerinformation_nonprofit_registration_number;
    this.s2_customerinformation_nonprofit_registration_date = getFormattedUnixDate(
      s2_customerinformation_nonprofit_registration_date
    );
    this.s2_customerinformation_customer_authorized = getBoolean(
      s2_customerinformation_customer_authorized
    );
    this.doesCustomerHaveLawnOrFenceOnPremise = doesCustomerHaveLawnOrFenceOnPremise;
  }
}

class CustomerShippingAddressModel {
  constructor(data) {
    const {
      s2_serviceshippingaddress_street_number,
      s2_serviceshippingaddress_street_name,
      s2_serviceshippingaddress_unit,
      s2_serviceshippingaddress_city,
      s2_serviceshippingaddress_province,
      s2_serviceshippingaddress_postal_code
    } = data || {};
    this.s2_serviceshippingaddress_street_number = s2_serviceshippingaddress_street_number;
    this.s2_serviceshippingaddress_street_name = s2_serviceshippingaddress_street_name;
    this.s2_serviceshippingaddress_unit = s2_serviceshippingaddress_unit;
    this.s2_serviceshippingaddress_city = s2_serviceshippingaddress_city;
    this.s2_serviceshippingaddress_province = s2_serviceshippingaddress_province;
    this.s2_serviceshippingaddress_postal_code = s2_serviceshippingaddress_postal_code;
  }
}

class CustomerBillingAddressModel {
  constructor(data) {
    const {
      s2_billingaddress_street_number,
      s2_billingaddress_street_name,
      s2_billingaddress_unit,
      s2_billingaddress_city,
      s2_billingaddress_province,
      s2_billingaddress_postal_code,
      s2_additionalcomments
    } = data || {};
    this.s2_billingaddress_street_number = s2_billingaddress_street_number;
    this.s2_billingaddress_street_name = s2_billingaddress_street_name;
    this.s2_billingaddress_unit = s2_billingaddress_unit;
    this.s2_billingaddress_city = s2_billingaddress_city;
    this.s2_billingaddress_province = s2_billingaddress_province;
    this.s2_billingaddress_postal_code = s2_billingaddress_postal_code;
    this.s2_additionalcomments = s2_additionalcomments;
  }
}

class EmergencyContactModel {
  constructor(data) {
    const {
      s2_customerinformation_emergency_name,
      s2_customerinformation_emergency_last_name,
      s2_customerinformation_emergency_telephone_number,
      s2_customerinformation_emergency_telephone_number2,
      s2_customerinformation_emergency_title,
      s2_customerinformation_emergency_password,
      preferredLanguageOfContact,
      preferredLanguageOfContactOne,
      preferredLanguageOfContactTwo,
      premiseContactNumber_emergencyContactDetails,
      extension_emergencyContactDetails
    } = data || {};
    this.s2_customerinformation_emergency_name = s2_customerinformation_emergency_name;
    this.s2_customerinformation_emergency_last_name = s2_customerinformation_emergency_last_name;
    this.premiseContactNumber_emergencyContactDetails = extension_emergencyContactDetails
      ? [
          premiseContactNumber_emergencyContactDetails,
          extension_emergencyContactDetails
        ].join('-')
      : premiseContactNumber_emergencyContactDetails;
    this.s2_customerinformation_emergency_telephone_number = s2_customerinformation_emergency_telephone_number;
    this.s2_customerinformation_emergency_telephone_number2 = s2_customerinformation_emergency_telephone_number2;
    this.s2_customerinformation_emergency_title = s2_customerinformation_emergency_title;
    this.s2_customerinformation_emergency_password = s2_customerinformation_emergency_password;
    this.preferredLanguageOfContact = preferredLanguageOfContact;
    this.preferredLanguageOfContactOne = preferredLanguageOfContactOne;
    this.preferredLanguageOfContactTwo = preferredLanguageOfContactTwo;
  }
}

class EmergencyContact2Model {
  constructor(data) {
    const {
      s2_customerinformation_emergency2_name,
      s2_customerinformation_emergency2_last_name,
      s2_customerinformation_emergency2_telephone_number,
      s2_customerinformation_emergency2_telephone_number2,
      s2_customerinformation_emergency2_title,
      s2_customerinformation_emergency2_password
    } = data || {};
    this.s2_customerinformation_emergency2_name = s2_customerinformation_emergency2_name;
    this.s2_customerinformation_emergency2_last_name = s2_customerinformation_emergency2_last_name;
    this.s2_customerinformation_emergency2_telephone_number = s2_customerinformation_emergency2_telephone_number;
    this.s2_customerinformation_emergency2_telephone_number2 = s2_customerinformation_emergency2_telephone_number2;
    this.s2_customerinformation_emergency2_title = s2_customerinformation_emergency2_title;
    this.s2_customerinformation_emergency2_password = s2_customerinformation_emergency2_password;
  }
}

class EmergencyContact3Model {
  constructor(data) {
    const {
      s2_customerinformation_emergency3_name,
      s2_customerinformation_emergency3_last_name,
      s2_customerinformation_emergency3_telephone_number,
      s2_customerinformation_emergency3_telephone_number2,
      s2_customerinformation_emergency3_title,
      s2_customerinformation_emergency3_password
    } = data || {};
    this.s2_customerinformation_emergency3_name = s2_customerinformation_emergency3_name;
    this.s2_customerinformation_emergency3_last_name = s2_customerinformation_emergency3_last_name;
    this.s2_customerinformation_emergency3_telephone_number = s2_customerinformation_emergency3_telephone_number;
    this.s2_customerinformation_emergency3_telephone_number2 = s2_customerinformation_emergency3_telephone_number2;
    this.s2_customerinformation_emergency3_title = s2_customerinformation_emergency3_title;
    this.s2_customerinformation_emergency3_password = s2_customerinformation_emergency3_password;
  }
}

class SigningAuthorityModel {
  constructor(data) {
    const {
      s2_customerinformation_signing_name,
      s2_customerinformation_signing_last_name,
      s2_customerinformation_signing_telephone_number,
      s2_customerinformation_signing_title,
      s2_customerinformation_signing_email_address
    } = data || {};
    this.s2_customerinformation_signing_name = s2_customerinformation_signing_name;
    this.s2_customerinformation_signing_last_name = s2_customerinformation_signing_last_name;
    this.s2_customerinformation_signing_telephone_number = s2_customerinformation_signing_telephone_number;
    this.s2_customerinformation_signing_title = s2_customerinformation_signing_title;
    this.s2_customerinformation_signing_email_address = s2_customerinformation_signing_email_address;
  }
}

class OrderEquipmentModel {
  constructor(data) {
    const { product_name, quantity } = data || {};
    this.product_name = product_name;
    this.quantity = quantity;
  }
}

class ProductSelectionModel {
  constructor(data, labels) {
    const {
      common_verbal_password,
      easy_payment,
      doesTheCustomerHavePrivateWifiConnection,
      whatIsUploadSpeed,
      doesTheCustomerHaveLteCoverage,
      evsPrimaryBaseCoupon,
      acquired_from,
      adt_subscriber,
      security_product,
      add_video,
      video_options,
      commitment_period,
      free_sensor_note,
      free_camera_note,
      additional_option,
      smart_camera_equipment,
      secureBusinessTerm,
      pricing_details,
      offers,
      telus_account_number,
      evs_offer_code,
      telus_account_phone_number,
      bell_alarmforce_customer,
      epp_offer_validation_code,
      notification_type,
      additionalcomments,
      orders_equipments,
      econtract_pin,
      how_to_receive_installation,
      preferred_installdate_1,
      preferred_installdate_2,
      preferred_installdate_3,
      customer_telus_products,
      customer_existing_security,
      referral_qualifiers,
      mobility_epp_account_number,
      address_primary_residence,
      CallToBookIt,
      customer_hours_of_availability,
      installation_preferred_arrival_window
    } = data || {};
    this.common_verbal_password = common_verbal_password;
    this.easy_payment = easy_payment;
    this.doesTheCustomerHavePrivateWifiConnection = doesTheCustomerHavePrivateWifiConnection;
    this.whatIsUploadSpeed = whatIsUploadSpeed;
    this.doesTheCustomerHaveLteCoverage = doesTheCustomerHaveLteCoverage;
    this.evsPrimaryBaseCoupon = evsPrimaryBaseCoupon;
    this.acquired_from = acquired_from;
    this.adt_subscriber = adt_subscriber;
    this.security_product = security_product;
    this.add_video = add_video;
    this.video_options = video_options;
    this.commitment_period = commitment_period;
    this.free_sensor_note = free_sensor_note;
    this.free_camera_note = free_camera_note;
    this.additional_option = additional_option;
    this.smart_camera_equipment = smart_camera_equipment;
    this.secureBusinessTerm = secureBusinessTerm;
    this.pricing_details = camel2title(pricing_details);
    this.mobility_epp_account_number = mobility_epp_account_number;
    this.address_primary_residence = address_primary_residence;
    this.offers = offers;
    this.telus_account_number = telus_account_number;
    this.bell_alarmforce_customer = bell_alarmforce_customer;
    this.epp_offer_validation_code = epp_offer_validation_code;
    this.evs_offer_code = evs_offer_code;
    this.telus_account_phone_number = telus_account_phone_number;
    this.notification_type = notification_type;
    this.customer_telus_products = ListDetails(
      customer_telus_products,
      labels.customer_telus_products
    );
    this.customer_existing_security = customer_existing_security;
    this.referral_qualifiers = ListDetails(
      referral_qualifiers,
      labels.referral_qualifiers
    );
    this.orders_equipments = OrderEquipments(
      OrderEquipmentModel,
      orders_equipments,
      labels
    );
    this.additionalcomments = additionalcomments;
    this.econtract_pin = econtract_pin;
    this.how_to_receive_installation = how_to_receive_installation;
    this.preferred_installdate_1 = preferred_installdate_1;
    this.preferred_installdate_2 = preferred_installdate_2;
    this.preferred_installdate_3 = preferred_installdate_3;
    this.CallToBookIt = CallToBookIt;
    this.customer_hours_of_availability = customer_hours_of_availability;
    this.installation_preferred_arrival_window = installation_preferred_arrival_window;
  }
}

class CopperInternetModel {
  constructor(data) {
    const keys = [
      'staticIP',
      'highestQualifiedSpeed',
      'qualifiedSpeed',
      'term',
      'regularMonthlyOffers',
      'regularOffers36MonthTerm',
      'promoDuration',
      'limitedTimeBasicOffer',
      'productWithInternet',
      'publicWifi',
      'telusBusinessWifi',
      'numberTelusWifiAccessPointsCopper'
    ];

    keys.forEach(key => {
      this[key] = data[key];
    });
  }
}

class FibreInternetModel {
  constructor(data) {
    const keys = [
      'staticIPsRequired',
      'requiresTnet',
      'termFibre',
      'qualifiedSpeedFibre',
      'regularMonthlyOffersFibre',
      'regularYearlyOffersFibre',
      'regularYearlyOffer',
      'limitedTimeOfferFibre',
      'limitedYearlyOffersFibre',
      'regularYearlyOfferFibreBundled',
      'fiberManagerSpecial',
      'staticIPRequiredFibre',
      'fiveYearlyFibrePromos',
      'switchCredit100',
      'terminateExistingContractFibre',
      'customerInvoiceWithTlcFibre',
      'customerTelusBuyOutPolicyFibre',
      'monthlyRateOtherProviderFibre',
      'promoDurationFibre',
      'productSelectionFibre',
      'limitedOfferFI',
      'limitedYearlyOffersFibre150',
      'limitedYearlyOffersFibre300',
      'internetType',
      'twoMonthsFreeFibre',
      'limitedTimeOfferYearly15g',
      'limitedMonthlyOfferFibre2_5G',
      'telusPublicWifiFibre',
      'telusBusinessWifi',
      'numberTelusWifiAccessPointsFibre',
      'additionalCommentsFibre'
    ];
    const camelCaseKeys = [
      'regularYearlyOfferFibreBundled',
      'fiberManagerSpecial',
      'staticIPRequiredFibre',
      'fiveYearlyFibrePromos'
    ];

    keys.forEach(key => {
      this[key] = camelCaseKeys.includes(key)
        ? camel2title(data[key])
        : data[key];
    });
  }
}

class BusinessWiFiModel {
  constructor(data) {
    const keys = [
      'numberTelusWifiAccessPointsTelusBusiness',
      'telusBusinessWifiTypeTelusBusiness',
      'confirmExistingTelusHSIA',
      'existingCustomerAccountNumber'
    ];

    keys.forEach(key => {
      this[key] = data[key];
    });
  }
}

class OfficePhoneModel {
  constructor(data) {
    const keys = [
      'type',
      'ratePlan',
      'setup',
      'lineDesignation',
      'phoneNumber',
      'callingFeatures',
      'longDistanceAddOns',
      'forbearance',
      'term',
      'regularOfferOfficePhone',
      'promoDuration',
      'twoMonthsDuration',
      'limitedTimeOfferOfficePhone',
      'pricingAndOffers',
      'tollFree',
      'officePhoneTerminateContract',
      'officePhoneInvoiceTLC',
      'officePhoneBuyoutPolicy',
      'officePhoneCustomerMontlyRate'
    ];

    keys.forEach(key => {
      this[key] = data[key];
    });
  }
}

class TelusOptikTvModel {
  constructor(data) {
    const keys = [
      'telusOptikTvIsThisAWinback',
      'telusOptikTvMonthlyRatePlan',
      'telusOptikTvProfileType',
      'telusOptikTvPricingAndOffers',
      'telusOptikTvPromoDuration',
      'telusOptikTvTwoMonthFree',
      'telusOptikTvFreeThemePacksTVNote',
      'telusOptikTvFreeThemePacksTVEliteNote',
      'telusOptikTvFreeThemePacks',
      'telusOptikTvAdditionalThemePacks',
      'telusOptikTvStingrayMusic',
      'telusOptikTvExtraThemePackChinese',
      'telusOptikTvExtraThemePackIndian',
      'telusOptikTvExtraThemePackOtherMulticultural',
      'telusOptikTvNumberWiredSetTopBoxes',
      'telusOptikTvNumberWirelessSetTopBoxes',
      'telusOptikTvMainSetTopBox',
      'telusOptikTvAdditionalSetTopBox',
      'telusOptikTvComments'
    ];

    keys.forEach(key => {
      this[key] = data[key];
    });

    this.telusOptikTvAdditionalSetTopBoxes = ListDetails(
      data.telusOptikTvAdditionalSetTopBoxes &&
        data.telusOptikTvAdditionalSetTopBoxes.map(i => Object.values(i)),
      'Item'
    );
  }
}

class OnSiteDetailsModel {
  constructor(data) {
    const {
      s2_customerinformation_it_name,
      s2_customerinformation_it_last_name,
      s2_customerinformation_it_telephone_number,
      s2_customerinformation_it_secondary_telephone_number,
      s2_customerinformation_it_email_address,
      preferred_arrival_window,
      hours_of_operation
    } = data || {};

    this.s2_customerinformation_it_name = s2_customerinformation_it_name;
    this.s2_customerinformation_it_last_name = s2_customerinformation_it_last_name;
    this.s2_customerinformation_it_telephone_number = s2_customerinformation_it_telephone_number;
    this.s2_customerinformation_it_secondary_telephone_number = s2_customerinformation_it_secondary_telephone_number;
    this.s2_customerinformation_it_email_address = s2_customerinformation_it_email_address;
    this.preferred_arrival_window = preferred_arrival_window;
    this.hours_of_operation = hours_of_operation;
  }
}

class StatusUpdateModel {
  constructor(data) {
    if (data && data.statusChangedBy) {
      const {
        statusChangedBy: { email, first_name, last_name },
        status_changed_at,
        status
      } = data || {};
      this.status_changed_by = `${first_name} ${last_name} (${email})`;
      this.status_changed_at = getFormattedDate(
        status_changed_at,
        'dddd, MMMM Do YYYY, h:mm:ss a'
      );
      this.status = status;
    }
  }
}

class OrderCommentsModel {
  constructor(data) {
    const { orders_comments } = data || {};
    this.orders_comments = OrderComments(orders_comments);
  }
}

export {
  SalesOrderCheckListPageModel,
  HsiaQualificationsPageModel,
  ChannelRepModel,
  OnSiteDetailsModel,
  AdministratorContactModel,
  CustomerInformationModel,
  CustomerShippingAddressModel,
  CustomerBillingAddressModel,
  EmergencyContactModel,
  EmergencyContact2Model,
  EmergencyContact3Model,
  SigningAuthorityModel,
  ProductSelectionModel,
  OrderCommentsModel,
  OrderSummaryModel,
  OptOrderSummaryModel,
  OrderEquipmentModel,
  StatusUpdateModel,
  CopperInternetModel,
  FibreInternetModel,
  BusinessWiFiModel,
  OfficePhoneModel,
  TelusOptikTvModel
};
